import { render, staticRenderFns } from "./MitEventsPage.vue?vue&type=template&id=788876d4&scoped=true"
import script from "./MitEventsPage.vue?vue&type=script&lang=js"
export * from "./MitEventsPage.vue?vue&type=script&lang=js"
import style0 from "./MitEventsPage.vue?vue&type=style&index=0&id=788876d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788876d4",
  null
  
)

export default component.exports